import {ZIDX, ZIDXPage} from "../../../../standalone/standaloneLibrary.js";

export class ZIDXAccountMlsGridServerEdit implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountMlsGridServerEditContainer";
    }
    render(){
        // console.log("mls grid server login edit");
    }
}